import { memo } from 'react';
import styled from '@emotion/styled';

type Props = {
  name: string;
  description: string;
  onClick: () => void;
  className?: string;
};

export const LandingCardPrompt = memo(({ name, description, onClick, className }: Props) => {
  const ariaLabel = description.trim().length > 0 ? `${name}. ${description}` : name;

  return (
    <PromptItem
      role="button"
      tabIndex={0}
      title={description}
      aria-label={ariaLabel}
      className={className}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick();
        }
      }}
    >
      <PromptWrap>
        <PromptText>{name}</PromptText>
      </PromptWrap>
    </PromptItem>
  );
});

LandingCardPrompt.displayName = 'LandingCardPrompt';

const PromptItem = styled.div({
  width: 195,
  flexShrink: 0,
  height: 100,
  backgroundColor: 'var(--pri-01)',
  borderRadius: 8,
  border: '1px solid #E5E7EB',

  '&:hover': {
    boxShadow: '0px 0px 12px 0px #0000001A',
    cursor: 'pointer',
  },
});

const PromptWrap = styled.div({
  padding: 15,
});

const PromptText = styled.div(({ theme }) => ({
  fontFamily: theme.fonts.regular,
  fontSize: 14,
  display: '-webkit-box',
  color: theme.palette.black.light1,
  WebkitLineClamp: 3,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
}));
